import api from '../Axios'; // Adjust path if needed

export const expertDashboardApi = {
  // Get Dashboard Home Stats & Upcoming Sessions
  getHomeData: async () => {
    const response = await api.get('/api/expert-dashboard/home');
    return response.data;
  },

  // 🟢 Update Expert Profile Settings
  // Accepts either a standard object or FormData (since we are uploading a file)
  updateSettings: async (data: Record<string, any> | FormData) => {
    const response = await api.put('/api/expert-dashboard/home/settings', data);
    return response.data;
  },

  // 🟢 NEW: Deactivate Account
  deactivateAccount: async () => {
    const response = await api.put('/api/expert-dashboard/home/deactivate');
    return response.data;
  }
};